import React from 'react';
import User_Creation from './User_Creation';

const User_MasterApp = () => {
  return (
  <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Edit User</h5>
          </div>
        </div>
        <User_Creation />
      </div>
    </div >
  );
};

export default User_MasterApp;
